export interface IListingInteractionType {
    name: string;
    listingInteractionTypeId: number;
    rank: null | number;
    description: string;
    activityTypeId: null | number;
  }
  
  export interface IListingInteractionTypeResponse {
    value: IListingInteractionType[];
  }
  
  export interface IUpdateListingInteractionType {
    listingInteractionTypeList: IListingInteractionType[];
  }

  // eslint-disable-next-line @typescript-eslint/no-redeclare
export const IListingInteractionType = {
    getDefault(): IListingInteractionType {
      return {
        name: '',
        listingInteractionTypeId: 0,
        rank: 0,
        description: '',
        activityTypeId: 0
      };
    },
  };
  